import axios from 'axios';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { fetchDefault, fetchFormAuth, setError } from 'src/fetch/common';
import { initSettlementPayload, initSettlementNtsPayload } from 'src/store/settlementInfo';
import { homeTaxInitData, homeTaxData } from 'src/static/sample/stepC';
import { dataSet, defDataSet, settlementDataSet, settlemenNtstDataSet } from './dataSet';
import _ from 'lodash';
const stateTimeStr = process.env.REACT_APP_REACTQUERY_STALETIME || '0';
const STALETIME = Number(stateTimeStr);

// SELECT(LIST) 정산결과
export const settlementInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/settlement/result/info';
  const fetchKey = 'SETTLEMENT_INFO';
  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    const infoData: any = data;
    const { resError, resData } = settlementDataSet(infoData, initSettlementPayload, null);
    console.log('[SETTLEMENT_INFO]:', paramSet, data, resData);
    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
      return resData;
    }
  } catch (e) {
    console.log('error:', e);
  }
};

// SELECT(LIST) 정산결과
export const settlementNtsInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/nts-pdf/stats';
  const fetchKey = 'SETTLEMENT_NTS_INFO';
  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    const infoData: any = data;
    console.log('[SETTLEMENT_NTS_INFO]:', paramSet, data);
    const { resError, resData } = settlemenNtstDataSet(infoData, initSettlementNtsPayload, null);
    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
      return resData;
    }
  } catch (e) {
    console.log('error:', e);
  }
};

// SELECT(LIST) 정산결과
export const selectNtsFileFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/nts-pdf/file/lst';
  const fetchKey = 'NTS_FILE_INFO';
  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    const infoData: any = data;
    console.log(`[${fetchKey}]`, paramSet, data);
    const { resError, resData } = defDataSet(infoData, initSettlementNtsPayload);
    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
      return resData;
    }
  } catch (e) {
    console.log('error:', e);
  }
};

// SELECT(LIST) 정산결과
export const deleteNtsFileFn = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/nts-pdf/del';
  const fetchKey = 'NTS_FILE_DELETE';
  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey, paramSet],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    console.log(`[${fetchKey}]`, paramSet, queryData);

    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
